import { Box, BoxProps, styled, Typography, TypographyProps } from '@mui/material'
import { ComponentType } from 'react'

export const ModalContainer: ComponentType<BoxProps> = styled( Box )<BoxProps>( ( { theme } ) => ( {
	padding: theme.spacing( 2, 2, 1, 2 ),
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	backgroundColor: theme.palette.background.paper,
	boxShadow: '24px',
	width: 500,
	minHeight: 100,
	flexDirection: 'row',
	borderRadius: theme.shape.borderRadius,
	[ theme.breakpoints.down( 564 ) ]: {
		width: 'calc(100% - 96px)',
	},
} ) )

export const ModalContainerBody: ComponentType<BoxProps> = styled( Box )( ( { theme } ) => ( {
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'flex-start',
	padding: theme.spacing( 1 ),
} ) )

export const ModalIconContainer: ComponentType<BoxProps> = styled( Box )( ( { theme } ) => ( {
	display: 'flex',
	height: 'inherit',
	alignItems: 'flex-start',
	justifyContent: 'flex-start',
	backgroundColor: theme.palette.background.default,
	marginRight: theme.spacing( 1 ),
} ) )

export const ModalContentContainer: ComponentType<BoxProps> = styled( Box )( ( ) => ( {
	display: 'flex',
	flexGrow: 1,
	flexDirection: 'column',
} ) )

export const ModalHeaderText: ComponentType<TypographyProps> = styled( Typography )( ( { theme } ) => ( {
	color: '#000',
	fontFeatureSettings: '"liga" off, "clig" off',
	fontFamily: theme.typography.fontFamily,
	fontSize: '21px', //these help the text line up with the icon
	fontStyle: 'normal',
	fontWeight: 600,
	lineHeight: '133.4%', //these help the text line up with the icon
} ) )

export const ModalContent: ComponentType<BoxProps> = styled( Box )( ( { theme } ) => ( {
	marginTop: theme.spacing( 2 ),
} ) )

export const ModalContentText: ComponentType<TypographyProps> = styled( Typography )( ( { theme } ) => ( {
	fontSize: '14px',
	color: '#757575',
	fontFeatureSettings: '"liga" off, "clig" off',
	fontFamily: theme.typography.fontFamily,
	fontWeight: theme.typography.fontWeightRegular,
	lineHeight: theme.typography.h5.lineHeight,
} ) )

export const ModalActions: ComponentType<BoxProps> = styled( Box )( ( { theme } ) => ( {
	display: 'flex',
	gap: theme.spacing( 1 ),
	justifyContent: 'flex-end',
	marginTop: theme.spacing( 2 ),
} ) )
